







































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getLiveDetail, getTextDetail, getVideoDetail } from '../api/index';
import { Toast } from 'vant';
@Component({
  components: {},
})
export default class BottomBar extends Vue {
  @Prop({ default: false }) video!: boolean;
  @Prop({ default: false }) detail!: boolean;
  @Prop({ default: false }) goods!: boolean;
  @Prop() item: any;
  public liveData: any = {};
  public liveTime = 0;
  public textTime = 0;
  public videoTime = 0;
  public id: any;
  public unOpen = false;
  public openIng = false;
  public opened = false;
  created() {
    this.id = this.$route.query.id;
    getLiveDetail(this.$route.query.id).then((res) => this.endLiveDetail(res));
    getTextDetail(this.$route.query.id).then(
      (res) => (this.textTime = res.data.createtime * 1000),
    );
    getVideoDetail(this.$route.query.id).then(
      (res) => (this.videoTime = res.data.createtime * 1000),
    );
  }
  endLiveDetail(res: any) {
    (this.liveData = res.data), (this.liveTime = res.data.start_time * 1000);
    if (this.liveTime === 0 || new Date().getTime() < this.liveTime) {
      this.unOpen = true;
    } else if (new Date().getTime() > res.data.end_time * 1000) {
      this.opened = true;
      this.unOpen = false;
    } else {
      this.unOpen = false;
    }
  }
  enterPath(path: any) {
    if (path === 'LivePage') {
      if (this.liveTime === 0 || new Date().getTime() < this.liveTime) {
        Toast.fail('尚未开始！');
      } else {
        if (new Date().getTime() < this.liveData.end_time * 1000) {
          this.$router.push({
            name: 'SSHDLiveRoom',
            params: { roomNumber: this.id },
          });
        } else {
          this.$router.push({
            path: `/20200710SSHD/${path}`,
            query: { id: this.$route.query.id },
          });
        }
      }
    } else if (path === 'TextPage') {
      if (this.textTime === 0 || new Date().getTime() < this.textTime) {
        Toast.fail('尚未开始！');
      } else {
        this.$router.push({
          path: `/20200710SSHD/${path}`,
          query: { id: this.$route.query.id },
        });
      }
    } else if (path === 'VideoPage') {
      console.log('this.videoTime', this.videoTime, new Date().getTime());
      if (this.videoTime === 0 || new Date().getTime() < this.videoTime) {
        Toast.fail('尚未开始！');
      } else {
        this.$router.push({
          path: `/20200710SSHD/${path}`,
          query: { id: this.$route.query.id },
        });
      }
    }
  }
}
